import fetch from 'auth/FetchInterceptor'

const JwtAuthService = {}

JwtAuthService.login = function (data) {
	return fetch({
		url: '/candidate/login',
		method: 'post',
		headers: {
			'public-request': 'true'
		},
		data: data
	})
}

JwtAuthService.signUp = function (data) {
	return fetch({
		url: '/candidate/register',
		method: 'post',
		headers: {
			'public-request': 'true'
		},
		data: data
	})
}
JwtAuthService.forgotPassword = function (data) {
	return fetch({
		url: '/candidate/forgot-password',
		method: 'post',
		headers: {
			'public-request': 'true'
		},
		data: data
	})
}
JwtAuthService.ResetPassword = function (data) {
	return fetch({
		url: '/candidate/reset-password',
		method: 'post',
		headers: {
			'public-request': 'true'
		},
		data: data
	})
}

JwtAuthService.verifyEmail = function(data){
	return fetch({
		url:'/candidate/verify-email',
		method:'post',
		headers: {
			'public-request': 'true'
		},
		data

	})
}


export default JwtAuthService